<template>
<div>
	<header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">การรับข้อมูลแบบโลเคชั่น</h1>
    </header>
    <div class="MarkdownContent">
      <p class="preindent">เมื่อทาง OneChat ได้รับข้อความจาก ผู้ใช้ที่ทำการส่งถึงบอทที่ลงทะเบียน webhook กับทางเรา เราจะส่งข้อมูลที่จำเป็นไปยัง webhook ตามข้อมูลต่อไปนี้</p>
    </div>

      <div>
      <v-tabs
        v-model="active"
        color="cyan"
        dark
        slider-color="yellow"
        style="width: 40vw;"
      >
        <v-tab key="user" ripple> user </v-tab>
        <v-tab key="group" ripple> group </v-tab>
        <v-tab-item key="user">
            <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessage"
              v-clipboard:copy="message">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"event"</span> : <span class="colorvalue">"message"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ua521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"timestamp"</span> : <span class="colorvalue">1462629479859</span>,
    <span class="colorkey">"message"</span> : {
        <span class="colorkey">"id"</span> : <span class="colorvalue">"3"</span>,
        <span class="colorkey">"type"</span> : <span class="colorvalue">"location"</span>,
        <span class="colorkey">"address"</span> : <span class="colorvalue">"Bangkok Thailand"</span>,
        <span class="colorkey">"latitude"</span> : <span class="colorvalue">35.65910807942215</span>,
        <span class="colorkey">"longitude"</span> : <span class="colorvalue">139.70372892916203</span>
    },
    <span class="colorkey">"source"</span> : {
        <span class="colorkey">"type_source"</span> : <span class="colorvalue">"user"</span>,
        <span class="colorkey">"user_id"</span> : <span class="colorvalue">"ABb77fxxxxx91yxxxxx222xxxxe664xxxx"</span>,
        <span class="colorkey">"email"</span> : <span class="colorvalue">"onechat@one.th"</span>,
        <span class="colorkey">"display_name"</span> : <span class="colorvalue">"One Chat"</span>
    }
  }

      </code>
        </v-tab-item>
        <!-- group -->
         <v-tab-item key="group">
            <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessage"
              v-clipboard:copy="messagegroup">
          <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
        </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"event"</span> : <span class="colorvalue">"message"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ua521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"timestamp"</span> : <span class="colorvalue">"1462629479859"</span>,
    <span class="colorkey">"message"</span> : {
        <span class="colorkey">"id"</span> : <span class="colorvalue">"3"</span>,
        <span class="colorkey">"type"</span> : <span class="colorvalue">"location"</span>,
        <span class="colorkey">"address"</span> : <span class="colorvalue">"Bangkok Thailand"</span>,
        <span class="colorkey">"latitude"</span> : <span class="colorvalue">35.65910807942215</span>,
        <span class="colorkey">"longitude"</span> : <span class="colorvalue">139.70372892916203</span>
    },
    <span class="colorkey">"source"</span> : {
        <span class="colorkey">"type_source"</span> : <span class="colorvalue">"group"</span>,
        <span class="colorkey">"group_id"</span> : <span class="colorvalue">"G5b1fxxxxxx94xxxxe763xxxx"</span>,
        <span class="colorkey">"group_name"</span> : <span class="colorvalue">"Test Bot"</span>,
        <span class="colorkey">"sender"</span> : {
            <span class="colorkey">"user_id"</span> : <span class="colorvalue">"R5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
            <span class="colorkey">"display_name"</span> : <span class="colorvalue">"One Chat"</span>,
            <span class="colorkey">"email"</span> : <span class="colorvalue">"onechat@one.th"</span> 
        }
    }
  }

      </code>
        </v-tab-item>
      </v-tabs>
  
    </div>

      <h3>รายละเอียดข้อมูลที่ได้รับ</h3>
      <table id="apimsgtable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>event</td>
          <td>String</td>
          <td>อีเว้นท์ของข้อมูลที่ได้รับ<br>
          	<ul><li>message เป็นอีเว้นท์เกี่ยวกับการรับข้อความ ทั้งที่เป็นtext file video audio image location และ sticker</li></ul>
        <!--   	<li>add_friend เป็นอีเว้นท์เมื่อมีการเพิ่มเพื่อนกับบอท</li>
          	<li>join เป็นอีเว้นท์เมื่อมีการชวนบอทเข้ากลุ่ม</li>
          	<li>leave เป็นอีเว้นท์เมื่อมีการลบบอทออกจากกลุ่ม</li> -->
          </td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>timestamp</td>
          <td>Integer</td>
          <td>เวลาที่มีการส่งข้อความถึงบอท</td>
        </tr>
        <tr>
          <td>message</td>
          <td>Dictionary (json)</td>
          <td>รายละเอียดของข้อความที่ถูกส่ง ประกอบด้วยข้อมูลดังนี้
            <ul>
<li>id คือ รหัสเฉพาะของแต่ละข้อความ มีประเภทข้อมูลเป็น String</li>
<li>type คือ ประเภทของข้อมูลที่ได้รับ ในตัวอย่างเป็น type = "location" หมายถึง เป็นข้อมูลประเภทโลเคชั่น</li>
<li>address คือ ชื่อสถานที่ที่ถูกส่งถึง</li>
<li>latitude คือ เลขแสดงละติจูด</li>
<li>longitude คือ เลขแสดงลองจิจูด</li>
</ul>
</td>
        </tr>
         <tr>
          <td>source</td>
          <td>Dictionary (json)</td>
          <td>รายละเอียดของบุคคลที่ส่งข้อความถึงบอท ประกอบด้วยข้อมูลดังนี้
            <ul><li>type_source คือประเภทของห้องแชท ซึ่งจะเป็น user หรือ group</li>
            <b> กรณี user</b>
            <li>user_id คือ รหัสเฉพาะของบุคคลที่ส่งข้อความ</li>
            <li>email คือ อีเมล์ของผู้ที่ทำการส่งข้อความ</li>
            <li>display_name คือ ชื่อของผู้ที่ทำการส่งข้อความ</li>
          <b> กรณี group</b>
            <li>group_id คือ รหัสเฉพาะของกลุ่ม</li>
            <li>group_name คือ ชื่อของกลุ่ม</li>
            <li>sender คือ ข้อมูล Dictionary (json) เกี่ยวกับบุุคคลที่ส่งข้อความ</li>
            - user_id คือ รหัสเฉพาะของบุคคลที่ส่งข้อความ<br> 
            - email คือ อีเมล์ของผู้ที่ทำการส่งข้อความ<br> 
            - display_name คือ ชื่อของผู้ที่ทำการส่งข้อความ<br>
          </ul>
            </td>
        </tr>
      </table>
     

</div>

</template>
<script type="text/javascript">
export default {
  data: () => ({
    message: '{\n\t"event" : "message",\n\t"bot_id" : "Ua521xx18350a5xxx2bxxxxx",\n\t"timestamp" : 1462629479859,\n\t"message" : {\n\t\t"id" : "3",\n\t\t"type" : "location",\n\t\t"address" : "Bangkok Thailand",\n\t\t"latitude" : 35.65910807942215,\n\t\t"longitude" : 139.70372892916203\n\t},\n\t"source" : {\n\t\t"type_source" : "user",\n\t\t"user_id" : "ABb77fxxxxx91yxxxxx222xxxxe664xxxx",\n\t\t"email" : "onechat@one.th",\n\t\t"display_name" : "One Chat"\n\t}\n}',
    messagegroup: '{\n\t"event" : "message",\n\t"bot_id" : "Ua521xx18350a5xxx2bxxxxx",\n\t"timestamp" : "1462629479859",\n\t"message" : {\n\t\t"id" : "3",\n\t\t"type" : "location",\n\t\t"address" : "Bangkok Thailand",\n\t\t"latitude" : 35.65910807942215,\n\t\t"longitude" : 139.70372892916203\n\t},\n\t"source" : {\n\t\t"type_source" : "group",\n\t\t"group_id" : "G5b1fxxxxxx94xxxxe763xxxx",\n\t\t"group_name" : "Test Bot",\n\t\t"sender" : {\n\t\t\t"user_id" : "R5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t\t\t"display_name" : "One Chat",\n\t\t\t"email" : "onechat@one.th"\n\t\t}\n\t}\n}'
    // ]
  })
}
</script>

<style type="text/css" scoped>
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
  max-height: 60vh;
  overflow-y: scroll;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
  max-height: 60vh;
  overflow-y: scroll;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 50vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}
</style>


// WEBPACK FOOTER //
// src/components/home/api/webhook/recievelocationwebhook.vue